module.exports = __webpack_public_path__ + "img/GS_Profile-Orion Shardanund.178d274c.png";